import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["color", "size"];
import React from 'react';
import { intrinsicComponent } from './utils/functions';
export var RotationLeft = intrinsicComponent(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 14 : _ref$size,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: ref,
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5667 25.0889H0.275391V1L11.2065 11.9311C15.6599 7.68012 20.5182 5.85827 26.591 5.85827C38.1294 5.85827 46.4289 12.336 49.6677 23.8744L47.441 24.4816C44.607 13.9554 37.3196 8.2874 26.7934 8.2874C21.3278 8.2874 17.2793 9.90684 13.0283 13.753L24.5667 25.0889Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6602 45.3317L17.0772 43.3075C16.4699 42.9026 15.8626 42.2953 15.2553 41.8905L13.6359 43.5099C14.2432 44.1172 15.0529 44.7244 15.6602 45.3317Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1135 47.5585L20.9232 45.3318C22.3402 45.9391 23.7572 46.1415 25.1742 46.3439L24.9718 48.7731C24.3645 48.7731 23.7572 48.5707 23.1499 48.3682C21.9354 48.1658 21.1257 47.9633 20.1135 47.5585ZM29.6276 46.5463C31.0446 46.3439 32.4616 46.1415 33.8786 45.7367L34.6883 47.9634C33.0689 48.5707 31.4495 48.7731 29.83 48.9755L29.6276 46.5463ZM38.1296 43.9148C39.3441 43.1051 40.5587 42.2954 41.7733 41.2833L43.3927 43.1051C42.1782 44.3197 40.7612 45.1294 39.3441 46.1415L38.1296 43.9148ZM44.4048 37.842C45.2145 36.6274 46.0243 35.2104 46.4291 33.9959L48.6558 34.8056C48.0485 36.425 47.2388 37.842 46.4291 39.2589L44.4048 37.842Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6438 29.5423L50.073 29.7448C50.2754 28.7326 50.2754 27.9229 50.2754 26.9107H47.8462C47.8462 27.9229 47.8463 28.7327 47.6438 29.5423Z",
    fill: color
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "50",
    height: "50",
    fill: "white",
    transform: "translate(0.275391)"
  }))));
});
export default RotationLeft;